import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n";
import { IMAGES } from "@/content/images";
import { SITE } from "@/content/site";
import { SEO } from "@/content/seo";

const setMeta = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const Seo = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    const page = SEO[lang][pathname] ?? SEO[lang]["/"];
    const canonicalUrl = `${SITE.url}${pathname === "/" ? "/" : pathname}`;
    const imageUrl = `${SITE.url}${IMAGES.hero}`;
    const locale = lang === "es" ? "es_MX" : "en_US";

    document.title = page.title;
    setMeta("name", "description", page.description);
    setMeta("property", "og:title", page.title);
    setMeta("property", "og:description", page.description);
    setMeta("property", "og:image", imageUrl);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE.brand);
    setMeta("property", "og:url", canonicalUrl);
    setMeta("property", "og:locale", locale);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", page.title);
    setMeta("name", "twitter:description", page.description);
    setMeta("name", "twitter:image", imageUrl);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: SITE.brand,
      url: SITE.url,
      image: imageUrl,
      logo: `${SITE.url}${IMAGES.logos.golden}`,
      telephone: SITE.contact.phoneE164,
      email: SITE.contact.email,
      address: {
        "@type": "PostalAddress",
        streetAddress: SITE.contact.address[0],
        addressLocality: "Cabo San Lucas",
        addressRegion: "Baja California Sur",
        addressCountry: "MX",
      },
      sameAs: [SITE.contact.facebook, SITE.contact.instagram],
    };
    let jsonLd = document.getElementById("local-business-schema");
    if (!jsonLd) {
      jsonLd = document.createElement("script");
      jsonLd.id = "local-business-schema";
      jsonLd.type = "application/ld+json";
      document.head.appendChild(jsonLd);
    }
    jsonLd.textContent = JSON.stringify(structuredData);
  }, [lang, pathname]);

  return null;
};

export default Seo;
